<template>
    <flex-element
        ref="outer"
        :element-type="elementType"
        class-default-inline="f-text-blue-700 hover:f-text-blue-500"
        :class="[containerClasses, linkClasses, activeClass(index)]"
        :tag="tag || 'div'"
        exclude-classes
    >
        <div ref="inner">
            <div
                v-for="(element) in values"
                :key="element.id"
                class="f-cursor-pointer"
                @click="event => onLinkClick(element)"
            >
                <slot :link-data="element">
                    <input
                        :id="element.value"
                        type="checkbox"
                        :name="name"
                        :value="element.value"
                        :checked="isChecked(element.value)"
                        class="f-hidden f-cursor-pointer"
                        @input="onInput"
                    >
                    <label :for="element.value" class="f-cursor-pointer" @click="event => onLinkClick(element)">
                        {{ element.item ? element.item.name: element.value }}  ({{ element.count }})
                    </label>
                </slot>
            </div>
        </div>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Facet } from '@/data/data-models';
import listenOnRootMixin from '@/mixins/listen-on-root';
import { STATE_CLASSES } from '@/data/constants/classes';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    mixins: [baseOrganism, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Facet Group',
        },

        values: {
            type: Array,
            default: () => [],
        },

        name: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            navId: '',
        };
    },

    computed: {
        containerClasses() {
            return this.htmlClass.filter((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        linkClasses() {
            return this.htmlClass.filter((className) => {
                const classDefinition = getClassDefinition(className);
                const { tailwindDefinitionProp } = classDefinition;

                return !this.containerClassGroups.includes(tailwindDefinitionProp);
            });
        },

        updatedElement() {
            return new Facet({
                ...this.updatedBaseElement,
                tag: this.tag || 'div',
            });
        },
    },

    watch: {
        values: {
            handler() {
                this.processSeeAll();
            },
            immediate: true,
        },
    },

    mounted() {
        this.processSeeAll();
    },

    methods: {
        onLinkClick(element) {
            this.$emit('facet-selected', element.value);
        },

        activeClass(index) {
            return index === this.activeIndex ? STATE_CLASSES.SELECTED : '';
        },

        isChecked(val) {
            const urlParams = new URLSearchParams(window.location.search);
            const facetValues = urlParams.get(this.name);
            if (facetValues) {
                return facetValues.indexOf(val) > -1;
            }
            return false;
        },

        onInput() {
            this.isSelected = true;
        },

        async processSeeAll() {
            await this.$nextTick();

            const outerHeight = this.$refs.outer?.$el.offsetHeight;
            const innerHeight = this.$refs.inner?.scrollHeight;

            if (this.values.length > 0 && outerHeight < innerHeight) {
                this.$emit('show-all', true);
            } else {
                this.$emit('show-all', false);
            }
        },
    },
};
</script>
